import React, { PropTypes } from 'react'
import styles from './index.css'

function Close({ onChange }) {
  return (
    <div onClick={onChange} className={styles.close}>
      <i className="icon-close"></i>
    </div>
  )
}


Close.propTypes = {
  onChange: PropTypes.func.isRequired
}


export default Close



/** WEBPACK FOOTER **
 ** ./src/components/Common/Close/index.js
 **/